import styled from 'styled-components'

export const Bar = styled.div`
  position: fixed;
  inset: 0 0 auto;
  z-index: ${({ theme }) => theme.layers.alwaysOnTop + 300};
  height: 46px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #263238;
  background: #fff;
  border-bottom: 1px solid #dfe5e8;
  box-shadow: 0 2px 8px rgba(22, 31, 36, 0.06);
  font-size: 13px;
`
export const CollapsedBar = styled.div`
  position: fixed;
  top: 8px;
  right: 12px;
  z-index: ${({ theme }) => theme.layers.alwaysOnTop + 300};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  color: #263238;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dfe5e8;
  border-radius: 9px;
  box-shadow: 0 3px 12px rgba(22, 31, 36, 0.14);
`
export const DragHandle = styled.button`
  width: 28px;
  height: 30px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  color: #66747c;
  background: transparent;
  font-size: 18px;
  line-height: 1;
  cursor: grab;
  touch-action: none;
  user-select: none;
  &:hover,
  &:focus-visible {
    color: #6758c9;
    background: #f1efff;
    outline: none;
  }
  &:active {
    cursor: grabbing;
  }
`
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const Button = styled.button<{ $primary?: boolean }>`
  height: 30px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1px solid ${({ $primary }) => ($primary ? '#91dfb2' : '#dfe4e8')};
  background: ${({ $primary }) => ($primary ? '#e7fff0' : '#fff')};
  color: ${({ $primary }) => ($primary ? '#087c43' : '#6758c9')};
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`
export const ToggleButton = styled.button`
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #dfe4e8;
  border-radius: 7px;
  color: #6758c9;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    border-color: #aaa1e6;
    outline: none;
  }
`
export const Countdown = styled.strong`
  padding: 3px 7px;
  color: #e78318;
  background: #fff3dc;
  border-radius: 999px;
`
export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.layers.alwaysOnTop + 400};
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(10, 18, 23, 0.56);
`
export const Modal = styled.div`
  width: min(900px, 100%);
  height: min(720px, calc(100vh - 40px));
  max-height: min(720px, calc(100vh - 40px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.background.secondary};
  box-shadow: ${({ theme }) => theme.shadows.xl};
`
export const ModalHeader = styled.header`
  flex: 0 0 auto;
  padding: 24px 24px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
`
export const ModalBody = styled.div`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding: 18px 24px;
`
export const Title = styled.h2`
  margin: 0 0 6px;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
`
export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.tertiary};
`
export const Input = styled.input`
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.background.input};
  outline: none;
  &::placeholder {
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
  &:focus {
    border-color: ${({ theme }) => theme.colors.accentColor};
  }
`
export const TableScroll = styled.div`
  position: relative;
  min-height: 250px;
  margin-top: 16px;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  border-radius: 10px;
`
export const Table = styled.table`
  width: 100%;
  min-width: 820px;
  border-collapse: collapse;
`
export const HeaderCell = styled.th`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 11px 12px;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme }) => theme.background.input};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  font-size: 12px;
  font-weight: 600;
`
export const TableRow = styled.tr<{ $selected?: boolean }>`
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? 'rgba(0,168,132,.08)' : 'transparent')};
  outline: none;
  &:hover,
  &:focus {
    background: rgba(0, 168, 132, 0.06);
  }
`
export const Cell = styled.td`
  max-width: 250px;
  padding: 11px 12px;
  color: ${({ theme }) => theme.colors.text.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  font-size: 13px;
  overflow-wrap: anywhere;
`
export const UserName = styled.strong`
  display: block;
  min-width: 130px;
  font-weight: 600;
`
export const CopyValue = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const CopyButton = styled.button`
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  background: transparent;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.accentColor};
    background: rgba(0, 168, 132, 0.1);
  }
`
export const ValueList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 130px;
`
export const Tag = styled.span`
  max-width: 180px;
  padding: 3px 7px;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme }) => theme.background.input};
  border: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  border-radius: 999px;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const MoreTag = styled(Tag)`
  color: ${({ theme }) => theme.colors.accentColor};
`
export const Muted = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
`
export const EmptyCell = styled.td`
  height: 200px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
`
export const LoadingState = styled.div`
  position: absolute;
  inset: 42px 0 0;
  display: grid;
  place-items: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  background: ${({ theme }) => `${theme.background.secondary}e6`};
`
export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 16px;
  div {
    display: flex;
    gap: 8px;
  }
`
export const PageInfo = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: 12px;
`
export const Select = styled.select`
  width: 100%;
  height: 42px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.background.input};
`
export const FieldGroup = styled.div`
  display: grid;
  gap: 7px;
  margin-top: 4px;
`
export const FieldLabel = styled.label`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
  font-weight: 600;
`
export const Footer = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-height: 68px;
  padding: 14px 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  background: ${({ theme }) => theme.background.secondary};
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
`
